module.exports = __webpack_public_path__ + "static/img/10.a00005b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/10.png
// module id = 3AJl
// module chunks = 0